import axios from "axios";
import { ENV } from "../configs/environment";

const DEFAULT_GAZE_REPORT_PATH =
  "/v5/seniors/{seniorId}/gaze-reports/{reportId}";
const DEFAULT_GAZE_REPORT_TRENDS_PATH = `${DEFAULT_GAZE_REPORT_PATH}/trends`;

const fillPath = (template, seniorId, reportId) =>
  template
    .replace("{seniorId}", encodeURIComponent(seniorId))
    .replace("{reportId}", encodeURIComponent(reportId));

export const buildGazeReportPath = (seniorId, reportId) =>
  fillPath(
    ENV.GAZE_REPORT_API_PATH || DEFAULT_GAZE_REPORT_PATH,
    seniorId,
    reportId,
  );

export const buildGazeReportTrendsPath = (seniorId, reportId) =>
  fillPath(
    ENV.GAZE_REPORT_TRENDS_API_PATH || DEFAULT_GAZE_REPORT_TRENDS_PATH,
    seniorId,
    reportId,
  );

// This client deliberately has no shared auth or response interceptors. A gaze
// report token authorizes one direct report request and must never establish or
// invalidate the normal staff session.
const gazeReportApi = axios.create({
  baseURL: ENV.API_URL,
  headers: { Accept: "application/json" },
});

const authorizedGet = async (path, token, signal) => {
  const response = await gazeReportApi.get(path, {
    headers: { Authorization: `Bearer ${token}` },
    signal,
  });
  return response.data;
};

export const getGazeReport = ({ seniorId, reportId, token, signal }) =>
  authorizedGet(buildGazeReportPath(seniorId, reportId), token, signal);

// Sessions up to and including the selected report, oldest first.
export const getGazeReportTrends = ({ seniorId, reportId, token, signal }) =>
  authorizedGet(buildGazeReportTrendsPath(seniorId, reportId), token, signal);

export default gazeReportApi;
